/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Oct 15 2024
 **/

import { useQueryClient } from "@tanstack/react-query";

type DMListMap = Map<string, WebServices.DirectMessage.List.Data[number]>;
type SpaceChatListMap = Map<string, WebServices.SpaceChat.List.Data[number]>;

export default function useChatVoteHandler() {
	const queryClient = useQueryClient();

	const dm = queryClient.getQueryData<DMListMap>(["getDMList"]);
	const space = queryClient.getQueryData<SpaceChatListMap>(["getSpaceChatList"]);

	return {
		dm,
		space
	};
}
